/* --- START: src/constants.js --- */
export const getLocalDateString = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const SUBJECT_PALETTE = [
  '#8B3A3A', '#2E5945', '#A0522D', '#4B5E85', '#546E7A',
  '#455A64', '#8D6E63', '#00695C', '#5D4037', '#283593',
  '#33691E', '#6A1B9A', '#4E342E', '#AD1457', '#37474F'
];

export const subjectMap = {
  torts: 'Torts',
  contracts: 'Contracts',
  property: 'Real Property',
  civpro: 'Civil Procedure',
  evidence: 'Evidence',
  criminal: 'Criminal Law and Procedure',
  constitution: 'Constitutional Law',
  agency: 'Agency',
  partnership: 'Partnership',
  corporations: 'Corporations',
  ucc: 'Secured Transactions',
  wills: 'Wills',
  trusts: 'Trusts and Estates',
  family: 'Family Law',
  conflicts: 'Conflict of Laws'
};

export const orderedSubjectKeys = Object.keys(subjectMap);

export const EXAM_DATES = [
    { label: "February 2026", value: "2026-02-24" },
    { label: "July 2026", value: "2026-07-28" }
];
/* --- END: src/constants.js --- */